

export const HomeIcon = () => {

    return(

        <svg xmlns="http://www.w3.org/2000/svg" width="35.384" height="33.17" viewBox="0 0 35.384 33.17">
            <g id="home_2_" data-name="home(2)" transform="translate(0 -16.017)">
                <path id="Path_2934" data-name="Path 2934"
                    d="M66.676,212.974h-23.5A3.183,3.183,0,0,1,40,209.795V193.069a1.106,1.106,0,1,1,2.211,0v16.726a.969.969,0,0,0,.968.968h23.5a.969.969,0,0,0,.968-.968V193.069a1.106,1.106,0,1,1,2.211,0v16.726A3.183,3.183,0,0,1,66.676,212.974Z"
                    transform="translate(-37.235 -163.787)" fill="#4e4e4e" />
                <path id="Path_2935" data-name="Path 2935"
                    d="M34.278,33.152a1.1,1.1,0,0,1-.782-.324L19.745,19.076a2.906,2.906,0,0,0-4.1,0L1.888,32.828A1.106,1.106,0,0,1,.324,31.264L14.076,17.512a5.12,5.12,0,0,1,7.232,0L35.06,31.264a1.106,1.106,0,0,1-.782,1.888Z"
                    fill="#4e4e4e" />
                <path id="Path_2936" data-name="Path 2936"
                    d="M185.952,302.358h-8.846A1.106,1.106,0,0,1,176,301.252v-9.813a3.459,3.459,0,0,1,3.455-3.455H183.6a3.459,3.459,0,0,1,3.455,3.455v9.813A1.106,1.106,0,0,1,185.952,302.358Zm-7.74-2.211h6.634v-8.708a1.245,1.245,0,0,0-1.244-1.244h-4.147a1.245,1.245,0,0,0-1.244,1.244Z"
                    transform="translate(-163.837 -253.171)" fill="#4e4e4e" />
            </g>
        </svg>

    )
}


export const SoundOffIcon = () => {

    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
        <g id="Group_4370" data-name="Group 4370" transform="translate(16160 8434)">
            <g id="speaker-filled-audio-tool" transform="translate(-16153 -8434.564)">
            <path id="Path_1529" data-name="Path 1529" d="M13.434,28.6a1.219,1.219,0,0,1-2,.939L4.77,24.015H1.219A1.219,1.219,0,0,1,0,22.8V17.938a1.22,1.22,0,0,1,1.219-1.22H4.77l6.667-5.524a1.22,1.22,0,0,1,2,.939V28.6ZM18.121,26.7c-.03,0-.058,0-.088,0a1.218,1.218,0,0,1-.862-.357l-.163-.164a1.219,1.219,0,0,1-.118-1.589A7.091,7.091,0,0,0,16.7,15.9a1.218,1.218,0,0,1,.084-1.631l.163-.163a1.193,1.193,0,0,1,.923-.355,1.221,1.221,0,0,1,.883.446,9.766,9.766,0,0,1,.254,12.012A1.22,1.22,0,0,1,18.121,26.7Zm5.042,3.768a1.221,1.221,0,0,1-.881.431H22.23a1.218,1.218,0,0,1-.862-.357l-.16-.16a1.22,1.22,0,0,1-.071-1.647,13,13,0,0,0-.215-16.979,1.22,1.22,0,0,1,.049-1.669l.16-.16a1.187,1.187,0,0,1,.9-.358,1.219,1.219,0,0,1,.876.409,15.657,15.657,0,0,1,.257,20.49Z" transform="translate(0 0)" fill="#707070"/>
            </g>
            <g id="Ellipse_678" data-name="Ellipse 678" transform="translate(-16160 -8434)" fill="none" stroke="#707070" strokeWidth="2">
            <circle cx="20" cy="20" r="20" stroke="none"/>
            <circle cx="20" cy="20" r="19" fill="none"/>
            </g>
            <line id="Line_18" data-name="Line 18" x2="27" y2="27" transform="translate(-16152.5 -8428.5)" fill="none" stroke="#707070" strokeLinecap="round" strokeWidth="2"/>
        </g>
        </svg>


    )
}
export const SoundIcon = () => {

    return(

        <svg xmlns="http://www.w3.org/2000/svg" width="41.754" height="33.17" viewBox="0 0 41.754 33.17">
            <g id="speaker-filled-audio-tool" transform="translate(0 -9.564)">
                <path id="Path_1528" data-name="Path 1529"
                    d="M20.89,39.165a1.9,1.9,0,0,1-3.106,1.459L7.417,32.034H1.9a1.9,1.9,0,0,1-1.9-1.9V22.584a1.9,1.9,0,0,1,1.9-1.9H7.417L17.783,12.1a1.9,1.9,0,0,1,3.106,1.46V39.165ZM28.176,36.2c-.046,0-.091,0-.136,0a1.894,1.894,0,0,1-1.341-.555l-.254-.254a1.9,1.9,0,0,1-.183-2.47,11.026,11.026,0,0,0-.292-13.511A1.9,1.9,0,0,1,26.1,16.88l.253-.254a1.855,1.855,0,0,1,1.436-.552,1.9,1.9,0,0,1,1.374.693,15.185,15.185,0,0,1,.4,18.678A1.9,1.9,0,0,1,28.176,36.2Zm7.839,5.86a1.9,1.9,0,0,1-1.37.671l-.079,0a1.9,1.9,0,0,1-1.341-.555l-.249-.249a1.9,1.9,0,0,1-.11-2.561,20.207,20.207,0,0,0-.335-26.4,1.9,1.9,0,0,1,.076-2.6l.249-.249a1.846,1.846,0,0,1,1.4-.557,1.9,1.9,0,0,1,1.363.636,24.346,24.346,0,0,1,.4,31.86Z"
                    transform="translate(0 0)" fill="#4e4e4e" />
            </g>
        </svg>
        
    )
}

export const InfoIcon = () => {

    return(

        <svg id="info_1_" data-name="info(1)" xmlns="http://www.w3.org/2000/svg" width="33.17" height="33.17"
            viewBox="0 0 33.17 33.17">
            <g id="Group_123" data-name="Group 123" transform="translate(0 0)">
                <g id="Group_122" data-name="Group 122">
                    <path id="Path_1495" data-name="Path 1495"
                        d="M203.318,222.415a1.482,1.482,0,0,1-.894-.2.928.928,0,0,1-.256-.762,3.955,3.955,0,0,1,.083-.693,7.618,7.618,0,0,1,.18-.776l.817-2.813a4.26,4.26,0,0,0,.166-.852c0-.312.042-.527.042-.651a1.822,1.822,0,0,0-.644-1.448,2.709,2.709,0,0,0-1.829-.554,4.745,4.745,0,0,0-1.386.229q-.734.229-1.545.547l-.236.914c.159-.055.353-.118.575-.187a2.356,2.356,0,0,1,.651-.1,1.33,1.33,0,0,1,.88.215,1,1,0,0,1,.229.755,3.283,3.283,0,0,1-.076.693q-.073.364-.187.769l-.824,2.826a8.077,8.077,0,0,0-.159.8,4.947,4.947,0,0,0-.049.693,1.808,1.808,0,0,0,.693,1.434,2.771,2.771,0,0,0,1.857.568,4.274,4.274,0,0,0,1.386-.2q.589-.2,1.573-.575l.222-.873a3.83,3.83,0,0,1-.547.18A2.631,2.631,0,0,1,203.318,222.415Z"
                        transform="translate(-184.706 -199.256)" fill="#4e4e4e" />
                    <path id="Path_1496" data-name="Path 1496"
                        d="M251.906,128.51a2.107,2.107,0,0,0-2.771,0,1.656,1.656,0,0,0,0,2.508,2.078,2.078,0,0,0,2.771,0,1.663,1.663,0,0,0,0-2.508Z"
                        transform="translate(-232.265 -119.609)" fill="#4e4e4e" />
                    <path id="Path_1497" data-name="Path 1497"
                        d="M16.585,0A16.585,16.585,0,1,0,33.17,16.585,16.585,16.585,0,0,0,16.585,0Zm0,31.662A15.077,15.077,0,1,1,31.662,16.585,15.077,15.077,0,0,1,16.585,31.662Z"
                        transform="translate(0 0)" fill="#4e4e4e" />
                </g>
            </g>
        </svg>
    )
}


export const FavouriteIcon = () => {

    return(
   
        <svg xmlns="http://www.w3.org/2000/svg" width="34.602" height="36.571" viewBox="0 0 34.602 36.571">
            <g id="Group_4364" data-name="Group 4364" transform="translate(-3011 9065)">
                <path id="Path_2932" data-name="Path 2932"
                    d="M41.714,46.674a21.6,21.6,0,0,0-34.6-.011,21.531,21.531,0,0,0,34.6.011Z"
                    transform="translate(3003.888 -9083.811)" fill="#4e4e4e" />
                <ellipse id="Ellipse_674" data-name="Ellipse 674" cx="8.715" cy="8.17" rx="8.715" ry="8.17"
                    transform="translate(3020 -9065)" fill="#4e4e4e" />
            </g>
        </svg>
    )
}


export const ProfileIcon = () => {

    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="41.892" height="36.571" viewBox="0 0 41.892 36.571">
            <path id="heart_1_" data-name="heart (1)"
                d="M29.68,22.543a12.464,12.464,0,0,0-5.549,1.281,12.293,12.293,0,0,0-3.185,2.259,12.293,12.293,0,0,0-3.185-2.259,12.465,12.465,0,0,0-5.549-1.281A12,12,0,0,0,0,34.3c0,4.591,2.519,9.466,7.487,14.491a71.992,71.992,0,0,0,12.756,9.889l.7.437.7-.437a71.988,71.988,0,0,0,12.756-9.889c4.968-5.025,7.487-9.9,7.487-14.491A12,12,0,0,0,29.68,22.543Z"
                transform="translate(0 -22.543)" fill="#4e4e4e" />
        </svg>


    )
}